import React from "react";
import Layout from "../../../../Components/Common/Layout";
import DashLayout from "../../../../Components/Admin/AdminDashLayout";
import useNavHeading from "../../../../Hooks/CommonHooks/useNavHeading ";
import MainSection from "./MainSection";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../../config/permission";

const FinancialStatements = () => {
  useNavHeading("Finance", `Statements`);

  return (
    <Layout title={"Financial Statements | Office Flow"}>
      <DashLayout>
        <ProtectedSection requiredPermission={PERMISSIONS.VIEW_FINANCIAL_STATEMENTS} title={"Financial Statements"}>
          <MainSection />
        </ProtectedSection>
      </DashLayout>
    </Layout>
  );
};

export default FinancialStatements

